import { tNow } from '../../i18n';
import { CANCELLED, errorCode, withCode } from '../../lib/errorCode';

/** A readable sign-in error with our internal code after it; empty when the person cancelled. */
export const friendlyAuthError = (e: unknown) => {
  const code = errorCode(e);
  if (code === CANCELLED) return '';
  const t = tNow().auth;
  return withCode(t.errors[code] ?? t.otherError, e);
};
